'use client';

import React from 'react';
import { Paper, Title, Text } from '@mantine/core';

interface AuditSearchBarProps {
  onSearch?: (query: string) => void;
}

export function AuditSearchBar({ onSearch }: AuditSearchBarProps) {
  return (
    <Paper shadow="sm" radius="md" p="lg">
      <Title order={4}>Audit Search</Title>
      <Text c="dimmed" size="sm">Search functionality coming soon</Text>
    </Paper>
  );
}